module.exports = __webpack_public_path__ + "static/media/hangman_1.7ef68bf2.svg";